// 犯罪类型

export default [
  { label: '抢劫', value: '1' },
  { label: '骚扰', value: '2' },
  { label: '儿童色情影像', value: '3' },
  { label: '儿童性犯罪', value: '4' },
  { label: '家庭暴力', value: '5' },
  { label: '药物犯罪', value: '6' },
  { label: '欺诈', value: '7' },
  { label: '身体伤害', value: '8' },
  { label: '绑架', value: '9' },
  { label: '过失杀人', value: '10' },
  { label: '谋杀', value: '11' },
  { label: '偷渡', value: '12' },
  { label: '性侵犯', value: '13' },
  { label: '偷窃', value: '14' },
  { label: '持械伤害', value: '15' },
  { label: '非法运输', value: '16' },
  { label: '其他', value: '17' },
];



// WEBPACK FOOTER //
// ./src/constants/crime-type-by-australia-elec.js